// Note, constants are replaced right after tsc built the project.
// Update scripts/post-build.ts when requirements here change.
export const pkg = {
    name: '@magicbell/react-headless',
    version: '5.5.1',
};
//# sourceMappingURL=pkg.js.map